// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__iAU5Y","clinicsSelect":"TableHeading_clinicsSelect__2THYd"};